import { formatDate } from '../../lib/formatters';
import { Pencil, Trash2, Building2, Ticket } from 'lucide-react';
import type { Promotion } from '../../types/promotion';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  EmptyState,
} from '../ui';

interface PromotionListProps {
  promotions: Promotion[];
  onEdit: (promotion: Promotion) => void;
  onDelete: (promotion: Promotion) => void;
  onManageCompanies: (promotion: Promotion) => void;
  isLoading?: boolean;
  isFiltered?: boolean;
}

function PromotionList({
  promotions,
  onEdit,
  onDelete,
  onManageCompanies,
  isLoading,
  isFiltered,
}: PromotionListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (promotions.length === 0) {
    return (
      <EmptyState
        icon={<Ticket className="h-12 w-12" />}
        title={isFiltered ? 'Nenhuma campanha encontrada' : 'Nenhuma campanha cadastrada'}
        description={
          isFiltered
            ? 'Tente ajustar sua pesquisa para encontrar o que procura'
            : 'Crie sua primeira campanha promocional para começar'
        }
      />
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nome</TableHead>
            <TableHead>Data Início</TableHead>
            <TableHead>Data Fim</TableHead>
            <TableHead className="relative">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {promotions.map(promotion => (
            <TableRow key={promotion.id}>
              <TableCell>{promotion.name}</TableCell>
              <TableCell>{formatDate(promotion.start_date)}</TableCell>
              <TableCell>{formatDate(promotion.end_date)}</TableCell>
              <TableCell className="text-right space-x-2">
                <Button
                  variant="ghost"
                  onClick={() => onManageCompanies(promotion)}
                  title="Empresas Participantes"
                >
                  <Building2 className="h-4 w-4 text-primary-600" />
                </Button>
                <Button variant="ghost" onClick={() => onEdit(promotion)} title="Editar">
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button variant="ghost" onClick={() => onDelete(promotion)} title="Excluir">
                  <Trash2 className="h-4 w-4 text-red-600" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PromotionList;
